import { Create } from 'react-admin';
import CreatePromotionalBalance from './CreatePromotionalBalance';

const PromotionalBalanceCreate = () => (
    <Create>
        <CreatePromotionalBalance />
    </Create>
);

export default PromotionalBalanceCreate;
